import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  id: "tabs_tn1",
  class: "tabs_tn"
}
const _hoisted_2 = { class: "wrap_tn" }
const _hoisted_3 = { class: "on_tn on_choose" }
const _hoisted_4 = { class: "it_3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "Lựa chọn phạm vi gởi tin nhắn", -1)
const _hoisted_6 = {
  key: 0,
  class: "it_3 it_ccc"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Lựa chọn khu vực gởi tin", -1)
const _hoisted_8 = {
  key: 1,
  class: "it_3 it_ccc"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, "A3. Giới tính ", -1)
const _hoisted_10 = { class: "ps" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "nam",
  style: {"margin-right":"60px"}
}, " Nam", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "nu" }, " Nữ", -1)
const _hoisted_13 = {
  key: 2,
  class: "it_3 it_ccc"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, "Chọn khách hàng gởi", -1)
const _hoisted_15 = {
  class: "flex align-items-center",
  style: {"width":"40px","alignment":"center"}
}
const _hoisted_16 = ["src"]
const _hoisted_17 = { style: {"width":"40px","alignment":"top"} }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("small", {
  id: "id-note1",
  class: "p-error"
}, "* Vui lòng chọn danh sách khách hàng gởi", -1)
const _hoisted_19 = {
  key: 3,
  class: "it_3 it_ccc"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h5", null, null, -1)
const _hoisted_21 = {
  key: 4,
  class: "it_3 it_ccc"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", null, "Lựa chọn nhóm gởi tin", -1)
const _hoisted_23 = { class: "it_full" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", null, "Nội dung tin nhắn", -1)
const _hoisted_25 = { class: "it_bt" }
const _hoisted_26 = {
  id: "tabs_tn2",
  class: "tabs_tn"
}
const _hoisted_27 = { class: "wrap_tn" }
const _hoisted_28 = { class: "on_tn on_choose" }
const _hoisted_29 = { class: "it_3" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", null, "Lựa chọn phạm vi gởi tin nhắn", -1)
const _hoisted_31 = {
  key: 0,
  class: "it_3 it_ccc"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", null, "Lựa chọn khu vực gởi tin", -1)
const _hoisted_33 = {
  key: 1,
  class: "it_3 it_ccc"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", null, "Lựa chọn nhóm gởi tin", -1)
const _hoisted_35 = {
  key: 2,
  class: "it_3 it_ccc"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", null, "A3. Giới tính ", -1)
const _hoisted_37 = { class: "ps" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", {
  for: "nam",
  style: {"margin-right":"60px"}
}, " Nam", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { for: "nu" }, " Nữ", -1)
const _hoisted_40 = {
  key: 3,
  class: "it_3 it_ccc"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", null, "Chọn khách hàng gởi", -1)
const _hoisted_42 = {
  class: "flex align-items-center",
  style: {"width":"40px","alignment":"center"}
}
const _hoisted_43 = ["src"]
const _hoisted_44 = { style: {"width":"40px","alignment":"top"} }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("small", {
  id: "id-note2",
  class: "p-error"
}, "* Vui lòng chọn danh sách khách hàng gởi", -1)
const _hoisted_46 = {
  key: 4,
  class: "it_3 it_ccc"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("h5", null, null, -1)
const _hoisted_48 = { class: "message-designer-grid" }
const _hoisted_49 = { class: "pannel_tk" }
const _hoisted_50 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_51 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_52 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_53 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", null, "Tiêu đề của khung chính", -1)
const _hoisted_55 = {
  key: 0,
  class: "p-error"
}
const _hoisted_56 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", null, "Nội dung khung chính", -1)
const _hoisted_58 = {
  key: 0,
  class: "p-error"
}
const _hoisted_59 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("label", null, "Đường dẫn hình ảnh chính", -1)
const _hoisted_61 = { class: "p-inputgroup" }
const _hoisted_62 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("label", null, "Đường dẫn khung chính", -1)
const _hoisted_64 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_65 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_66 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_67 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", null, "Tiêu đề của tham số 1", -1)
const _hoisted_69 = {
  key: 0,
  class: "p-error"
}
const _hoisted_70 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("label", null, "Đường dẫn hình ảnh của tham số 1", -1)
const _hoisted_72 = { class: "p-inputgroup" }
const _hoisted_73 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("label", null, "Loại hành động tham số 1", -1)
const _hoisted_75 = {
  key: 0,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_76 = /*#__PURE__*/_createElementVNode("label", null, "Đường dẫn của tham số 1", -1)
const _hoisted_77 = {
  key: 1,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_78 = /*#__PURE__*/_createElementVNode("label", null, "Nội dung tin nhắn của tham số 1", -1)
const _hoisted_79 = {
  key: 0,
  class: "p-error"
}
const _hoisted_80 = {
  key: 2,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_81 = /*#__PURE__*/_createElementVNode("label", null, "Nội dung tin nhắn sms 1", -1)
const _hoisted_82 = {
  key: 0,
  class: "p-error"
}
const _hoisted_83 = {
  key: 3,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_84 = /*#__PURE__*/_createElementVNode("label", null, "Thông tin số điện thoại 1", -1)
const _hoisted_85 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_86 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("label", null, "Tiêu đề của tham số 2", -1)
const _hoisted_88 = {
  key: 0,
  class: "p-error"
}
const _hoisted_89 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("label", null, "Đường dẫn hình ảnh của tham số 2", -1)
const _hoisted_91 = { class: "p-inputgroup" }
const _hoisted_92 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("label", null, "Loại hành động tham số 2", -1)
const _hoisted_94 = {
  key: 0,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_95 = /*#__PURE__*/_createElementVNode("label", null, "Đường dẫn của tham số 2", -1)
const _hoisted_96 = {
  key: 1,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_97 = /*#__PURE__*/_createElementVNode("label", null, "Nội dung tin nhắn của tham số 2", -1)
const _hoisted_98 = {
  key: 0,
  class: "p-error"
}
const _hoisted_99 = {
  key: 2,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_100 = /*#__PURE__*/_createElementVNode("label", null, "Nội dung tin nhắn sms 2", -1)
const _hoisted_101 = {
  key: 0,
  class: "p-error"
}
const _hoisted_102 = {
  key: 3,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_103 = /*#__PURE__*/_createElementVNode("label", null, "Thông tin số điện thoại 2", -1)
const _hoisted_104 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_105 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("label", null, "Tiêu đề của tham số 3", -1)
const _hoisted_107 = {
  key: 0,
  class: "p-error"
}
const _hoisted_108 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("label", null, "Đường dẫn hình ảnh của tham số 3", -1)
const _hoisted_110 = { class: "p-inputgroup" }
const _hoisted_111 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("label", null, "Loại hành động tham số 3", -1)
const _hoisted_113 = {
  key: 0,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_114 = /*#__PURE__*/_createElementVNode("label", null, "Đường dẫn của tham số 3", -1)
const _hoisted_115 = {
  key: 1,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_116 = /*#__PURE__*/_createElementVNode("label", null, "Nội dung tin nhắn của tham số 3", -1)
const _hoisted_117 = {
  key: 0,
  class: "p-error"
}
const _hoisted_118 = {
  key: 2,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_119 = /*#__PURE__*/_createElementVNode("label", null, "Nội dung tin nhắn sms 3", -1)
const _hoisted_120 = {
  key: 0,
  class: "p-error"
}
const _hoisted_121 = {
  key: 3,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_122 = /*#__PURE__*/_createElementVNode("label", null, "Thông tin số điện thoại 3", -1)
const _hoisted_123 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_124 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_125 = /*#__PURE__*/_createElementVNode("label", null, "Tiêu đề của tham số 4", -1)
const _hoisted_126 = {
  key: 0,
  class: "p-error"
}
const _hoisted_127 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_128 = /*#__PURE__*/_createElementVNode("label", null, "Đường dẫn hình ảnh của tham số 4", -1)
const _hoisted_129 = { class: "p-inputgroup" }
const _hoisted_130 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_131 = /*#__PURE__*/_createElementVNode("label", null, "Loại hành động tham số 4", -1)
const _hoisted_132 = {
  key: 0,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_133 = /*#__PURE__*/_createElementVNode("label", null, "Đường dẫn của tham số 4", -1)
const _hoisted_134 = {
  key: 1,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_135 = /*#__PURE__*/_createElementVNode("label", null, "Nội dung tin nhắn của tham số 4", -1)
const _hoisted_136 = {
  key: 0,
  class: "p-error"
}
const _hoisted_137 = {
  key: 2,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_138 = /*#__PURE__*/_createElementVNode("label", null, "Nội dung tin nhắn sms 4", -1)
const _hoisted_139 = {
  key: 0,
  class: "p-error"
}
const _hoisted_140 = {
  key: 3,
  class: "p-field p-col p-col-12 p-md-6 p-lg-6"
}
const _hoisted_141 = /*#__PURE__*/_createElementVNode("label", null, "Thông tin số điện thoại 4", -1)
const _hoisted_142 = { class: "bt_gtn" }
const _hoisted_143 = { class: "message-preview-panel" }
const _hoisted_144 = { class: "message-preview-card" }
const _hoisted_145 = /*#__PURE__*/_createElementVNode("div", { class: "message-preview-heading" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "message-preview-title" }, "Xem trước tin nhắn sẽ được gởi"),
    /*#__PURE__*/_createElementVNode("div", { class: "message-preview-subtitle" }, "Cập nhật theo nội dung đang nhập")
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "message-preview-icon" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "pi pi-mobile" })
  ])
], -1)
const _hoisted_146 = { class: "zalo-preview-phone" }
const _hoisted_147 = /*#__PURE__*/_createElementVNode("div", { class: "zalo-preview-topbar" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-chevron-left" }),
  /*#__PURE__*/_createElementVNode("span", null, "Zalo OA Preview"),
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-ellipsis-h" })
], -1)
const _hoisted_148 = { class: "zalo-preview-body" }
const _hoisted_149 = { class: "zalo-preview-main-image" }
const _hoisted_150 = ["src"]
const _hoisted_151 = {
  key: 1,
  class: "zalo-preview-placeholder"
}
const _hoisted_152 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-image" }, null, -1)
const _hoisted_153 = /*#__PURE__*/_createElementVNode("span", null, "Ảnh chính", -1)
const _hoisted_154 = [
  _hoisted_152,
  _hoisted_153
]
const _hoisted_155 = { class: "zalo-preview-main-content" }
const _hoisted_156 = { class: "zalo-preview-main-title" }
const _hoisted_157 = { class: "zalo-preview-main-text" }
const _hoisted_158 = { class: "zalo-preview-items" }
const _hoisted_159 = { class: "zalo-preview-item-image" }
const _hoisted_160 = ["src"]
const _hoisted_161 = {
  key: 1,
  class: "pi pi-image"
}
const _hoisted_162 = { class: "zalo-preview-item-content" }
const _hoisted_163 = { class: "zalo-preview-item-title" }
const _hoisted_164 = {
  key: 0,
  class: "zalo-preview-item-text"
}
const _hoisted_165 = {
  key: 0,
  class: "zalo-preview-empty"
}
const _hoisted_166 = { class: "tum_lunm" }
const _hoisted_167 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_168 = { id: "loading" }
const _hoisted_169 = /*#__PURE__*/_createElementVNode("label", null, "Đang gởi tin nhắn, vui lòng chờ ...", -1)
const _hoisted_170 = { class: "p-field p-col-10 p-sm-10 p-md-10" }
const _hoisted_171 = { class: "card" }
const _hoisted_172 = { class: "p-field p-col-10 p-sm-10 p-md-10" }
const _hoisted_173 = { class: "image-picker-modal" }
const _hoisted_174 = { class: "image-picker-header" }
const _hoisted_175 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", null, "Tập tin lưu trên máy chủ"),
  /*#__PURE__*/_createElementVNode("p", null, "Chọn một ảnh để gán vào khung đang chỉnh.")
], -1)
const _hoisted_176 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-times" }, null, -1)
const _hoisted_177 = [
  _hoisted_176
]
const _hoisted_178 = { class: "image-picker-toolbar" }
const _hoisted_179 = {
  key: 0,
  class: "image-picker-grid"
}
const _hoisted_180 = ["onClick"]
const _hoisted_181 = ["src"]
const _hoisted_182 = ["title"]
const _hoisted_183 = { class: "image-picker-check" }
const _hoisted_184 = /*#__PURE__*/_createElementVNode("span", null, "Chọn xóa", -1)
const _hoisted_185 = {
  key: 1,
  class: "image-picker-empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Slider = _resolveComponent("Slider")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Button = _resolveComponent("Button")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputMask = _resolveComponent("InputMask")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_Checkbox = _resolveComponent("Checkbox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TabView, null, {
      default: _withCtx(() => [
        _createVNode(_component_TabPanel, { header: "Gởi tin nhắn thông thường" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createVNode(_component_Dropdown, {
                      id: "kind",
                      modelValue: $setup.action,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.action) = $event)),
                      options: $setup.lsAction,
                      optionLabel: "label",
                      optionValue: "value"
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  ($setup.action == 'location')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _hoisted_7,
                        _createVNode(_component_Dropdown, {
                          id: "location",
                          modelValue: $setup.province,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.province) = $event)),
                          options: $setup.listProvince,
                          optionLabel: "provinceName",
                          optionValue: "provinceCode",
                          filter: true,
                          showClear: true
                        }, null, 8, ["modelValue", "options"])
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.action == 'gender')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _hoisted_9,
                        _createElementVNode("div", _hoisted_10, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            id: "nam",
                            name: "sex",
                            value: "Nam",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.gender) = $event))
                          }, null, 512), [
                            [_vModelRadio, $setup.gender]
                          ]),
                          _hoisted_11,
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            id: "nu",
                            name: "sex",
                            value: "Nữ",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.gender) = $event))
                          }, null, 512), [
                            [_vModelRadio, $setup.gender]
                          ]),
                          _hoisted_12
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.action == 'customer')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _hoisted_14,
                        _createVNode(_component_MultiSelect, {
                          modelValue: $setup.listIdMessage,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.listIdMessage) = $event)),
                          options: $setup.listCustomer,
                          optionLabel: "name",
                          placeholder: "Chọn tài khoản",
                          filter: true,
                          style: {"height":"35px"}
                        }, {
                          option: _withCtx((slotProps) => [
                            _createElementVNode("div", _hoisted_15, [
                              (slotProps.option.imageUrl)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: slotProps.option.imageUrl,
                                    style: {"width":"40px","margin-right":"3px"}
                                  }, null, 8, _hoisted_16))
                                : _createCommentVNode("", true),
                              _createElementVNode("label", _hoisted_17, _toDisplayString(slotProps.option.name), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options"]),
                        _hoisted_18
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.action == 'age')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("label", null, "Chọn phạm vi độ tuổi: " + _toDisplayString($setup.age), 1),
                        _hoisted_20,
                        _createVNode(_component_Slider, {
                          modelValue: $setup.age,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.age) = $event)),
                          range: true
                        }, null, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.action == 'group')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _hoisted_22,
                        _createVNode(_component_Dropdown, {
                          id: "group",
                          modelValue: $setup.idGroup,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.idGroup) = $event)),
                          options: $setup.listGroup,
                          optionLabel: "groupName",
                          optionValue: "id",
                          filter: true,
                          showClear: true
                        }, null, 8, ["modelValue", "options"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createVNode(_component_Textarea, {
                      id: "message",
                      type: "text",
                      modelValue: $setup.message.mess,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.message.mess) = $event)),
                      style: {"height":"100px"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_Button, {
                      label: "Gởi tin nhắn",
                      icon: "pi pi-plus-circle",
                      iconPos: "left",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.doSendMessage())),
                      disabled: !$setup.valid()
                    }, null, 8, ["disabled"])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_TabPanel, { header: "Đăng bài viết" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _hoisted_30,
                    _createVNode(_component_Dropdown, {
                      id: "kind2",
                      modelValue: $setup.action2,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.action2) = $event)),
                      options: $setup.lsAction,
                      optionLabel: "label",
                      optionValue: "value"
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  ($setup.action == 'location')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _hoisted_32,
                        _createVNode(_component_Dropdown, {
                          id: "location2",
                          modelValue: $setup.province2,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.province2) = $event)),
                          options: $setup.listProvince,
                          optionLabel: "provinceName",
                          optionValue: "provinceCode",
                          filter: true,
                          showClear: true
                        }, null, 8, ["modelValue", "options"])
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.action2 == 'group')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _hoisted_34,
                        _createVNode(_component_Dropdown, {
                          id: "group2",
                          modelValue: $setup.idGroup2,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.idGroup2) = $event)),
                          options: $setup.listGroup,
                          optionLabel: "groupName",
                          optionValue: "id",
                          filter: true,
                          showClear: true
                        }, null, 8, ["modelValue", "options"])
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.action2 == 'gender')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        _hoisted_36,
                        _createElementVNode("div", _hoisted_37, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            id: "nam2",
                            name: "sex",
                            value: "Nam",
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.gender2) = $event))
                          }, null, 512), [
                            [_vModelRadio, $setup.gender2]
                          ]),
                          _hoisted_38,
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            id: "nu2",
                            name: "sex",
                            value: "Nữ",
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.gender2) = $event))
                          }, null, 512), [
                            [_vModelRadio, $setup.gender2]
                          ]),
                          _hoisted_39
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.action2 == 'customer')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                        _hoisted_41,
                        _createVNode(_component_MultiSelect, {
                          modelValue: $setup.listId,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.listId) = $event)),
                          options: $setup.listCustomer,
                          optionLabel: "name",
                          placeholder: "Chọn tài khoản",
                          filter: true,
                          style: {"height":"35px"}
                        }, {
                          option: _withCtx((slotProps) => [
                            _createElementVNode("div", _hoisted_42, [
                              (slotProps.option.imageUrl)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: slotProps.option.imageUrl,
                                    style: {"width":"40px","margin-right":"3px"}
                                  }, null, 8, _hoisted_43))
                                : _createCommentVNode("", true),
                              _createElementVNode("label", _hoisted_44, _toDisplayString(slotProps.option.name), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options"]),
                        _hoisted_45
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.action2 == 'age')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                        _createElementVNode("label", null, "Chọn phạm vi độ tuổi: " + _toDisplayString($setup.age2), 1),
                        _hoisted_47,
                        _createVNode(_component_Slider, {
                          modelValue: $setup.age2,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.age2) = $event)),
                          range: true
                        }, null, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _createVNode(_component_Panel, { header: "Thiết kế khung chính của tin nhắn" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("div", _hoisted_51, [
                            _createElementVNode("div", _hoisted_52, [
                              _createElementVNode("div", _hoisted_53, [
                                _hoisted_54,
                                _createVNode(_component_Textarea, {
                                  id: "titleMain",
                                  type: "text",
                                  modelValue: $setup.element1.title,
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.element1.title) = $event))
                                }, null, 8, ["modelValue"]),
                                ($setup.element1.title?.length > 0)
                                  ? (_openBlock(), _createElementBlock("small", _hoisted_55, "Tiêu đề đang có độ dài " + _toDisplayString($setup.element1.title?.length) + " ký tự (tối đa 100 ký tự).", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_56, [
                                _hoisted_57,
                                _createVNode(_component_Textarea, {
                                  id: "subtitleMain",
                                  type: "text",
                                  modelValue: $setup.element1.subtitle,
                                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.element1.subtitle) = $event)),
                                  autoResize: "",
                                  rows: "10"
                                }, null, 8, ["modelValue"]),
                                ($setup.element1.subtitle?.length > 0)
                                  ? (_openBlock(), _createElementBlock("small", _hoisted_58, "Nội dung đang có độ dài " + _toDisplayString($setup.element1.subtitle?.length) + " ký tự (tối đa 500 ký tự).", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_59, [
                                _hoisted_60,
                                _createElementVNode("div", _hoisted_61, [
                                  _createVNode(_component_Textarea, {
                                    id: "imageUrlMain",
                                    type: "text",
                                    modelValue: $setup.element1.image_url,
                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.element1.image_url) = $event))
                                  }, null, 8, ["modelValue"]),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "choose-image-button",
                                    onClick: _cache[19] || (_cache[19] = ($event: any) => ($setup.showListImage(1)))
                                  }, "chọn hình")
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_62, [
                                _hoisted_63,
                                _createVNode(_component_Textarea, {
                                  id: "defaultUrl",
                                  type: "text",
                                  modelValue: $setup.element1.url,
                                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.element1.url) = $event))
                                }, null, 8, ["modelValue"])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Panel, { header: "Thiết kế thành phần" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_64, [
                          _createElementVNode("div", _hoisted_65, [
                            _createVNode(_component_Accordion, {
                              multiple: true,
                              activeIndex: $setup.messageParamActiveIndex,
                              "onUpdate:activeIndex": _cache[53] || (_cache[53] = ($event: any) => (($setup.messageParamActiveIndex) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_AccordionTab, { header: "Tham số 1" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_66, [
                                      _createElementVNode("div", _hoisted_67, [
                                        _hoisted_68,
                                        _createVNode(_component_InputText, {
                                          id: "title1",
                                          type: "text",
                                          modelValue: $setup.element2.title,
                                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (($setup.element2.title) = $event))
                                        }, null, 8, ["modelValue"]),
                                        ($setup.element2.title?.length > 0)
                                          ? (_openBlock(), _createElementBlock("small", _hoisted_69, "Tiêu đề đang có độ dài " + _toDisplayString($setup.element2.title?.length) + " ký tự (tối đa 100 ký tự).", 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("div", _hoisted_70, [
                                        _hoisted_71,
                                        _createElementVNode("div", _hoisted_72, [
                                          _createVNode(_component_InputText, {
                                            id: "imageUrl1",
                                            type: "text",
                                            modelValue: $setup.element2.image_url,
                                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (($setup.element2.image_url) = $event))
                                          }, null, 8, ["modelValue"]),
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "choose-image-button",
                                            onClick: _cache[23] || (_cache[23] = ($event: any) => ($setup.showListImage(2)))
                                          }, "chọn hình")
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_73, [
                                        _hoisted_74,
                                        _createVNode(_component_Dropdown, {
                                          modelValue: $setup.element2.type,
                                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (($setup.element2.type) = $event)),
                                          options: $setup.list,
                                          optionLabel: "label",
                                          optionValue: "param",
                                          showClear: "true"
                                        }, null, 8, ["modelValue", "options"])
                                      ]),
                                      ($setup.element2.type == 1)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                                            _hoisted_76,
                                            _createVNode(_component_InputText, {
                                              id: "defaultUrl1",
                                              type: "text",
                                              modelValue: $setup.element2.url,
                                              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (($setup.element2.url) = $event))
                                            }, null, 8, ["modelValue"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (($setup.element2.type == 2)||($setup.element2.type == 3))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                            _hoisted_78,
                                            _createVNode(_component_InputText, {
                                              id: "automessage",
                                              type: "text",
                                              modelValue: $setup.element2.payload,
                                              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (($setup.element2.payload) = $event))
                                            }, null, 8, ["modelValue"]),
                                            ($setup.element2.payload?.length > 0)
                                              ? (_openBlock(), _createElementBlock("small", _hoisted_79, "Nội dung tin nhắn có độ dài " + _toDisplayString($setup.element2.payload?.length) + " ký tự (tối đa 1000 ký tự).", 1))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      ($setup.element2.type == 4)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                                            _hoisted_81,
                                            _createVNode(_component_InputText, {
                                              id: "smscontent",
                                              type: "text",
                                              modelValue: $setup.payload1.content,
                                              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (($setup.payload1.content) = $event))
                                            }, null, 8, ["modelValue"]),
                                            ($setup.payload1.content?.length > 0)
                                              ? (_openBlock(), _createElementBlock("small", _hoisted_82, "Nội dung tin nhắn có độ dài " + _toDisplayString($setup.payload1.content?.length) + " ký tự (tối đa 160 ký tự).", 1))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (($setup.element2.type == 4)||($setup.element2.type == 5))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                                            _hoisted_84,
                                            _createVNode(_component_InputMask, {
                                              mask: "(9999)999999",
                                              modelValue: $setup.payload1.phone_code,
                                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (($setup.payload1.phone_code) = $event)),
                                              placeholder: ""
                                            }, null, 8, ["modelValue"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_AccordionTab, { header: "Tham số 2" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_85, [
                                      _createElementVNode("div", _hoisted_86, [
                                        _hoisted_87,
                                        _createVNode(_component_InputText, {
                                          id: "title2",
                                          type: "text",
                                          modelValue: $setup.element3.title,
                                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (($setup.element3.title) = $event))
                                        }, null, 8, ["modelValue"]),
                                        ($setup.element3.title?.length > 0)
                                          ? (_openBlock(), _createElementBlock("small", _hoisted_88, "Tiêu đề đang có độ dài " + _toDisplayString($setup.element3.title?.length) + " ký tự (tối đa 100 ký tự).", 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("div", _hoisted_89, [
                                        _hoisted_90,
                                        _createElementVNode("div", _hoisted_91, [
                                          _createVNode(_component_InputText, {
                                            id: "imageUrl2",
                                            type: "text",
                                            modelValue: $setup.element3.image_url,
                                            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (($setup.element3.image_url) = $event))
                                          }, null, 8, ["modelValue"]),
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "choose-image-button",
                                            onClick: _cache[31] || (_cache[31] = ($event: any) => ($setup.showListImage(3)))
                                          }, "chọn hình")
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_92, [
                                        _hoisted_93,
                                        _createVNode(_component_Dropdown, {
                                          modelValue: $setup.element3.type,
                                          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (($setup.element3.type) = $event)),
                                          options: $setup.list,
                                          optionLabel: "label",
                                          optionValue: "param",
                                          showClear: "true"
                                        }, null, 8, ["modelValue", "options"])
                                      ]),
                                      ($setup.element3.type == 1)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                                            _hoisted_95,
                                            _createVNode(_component_InputText, {
                                              id: "defaultUrl2",
                                              type: "text",
                                              modelValue: $setup.element3.url,
                                              "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (($setup.element3.url) = $event))
                                            }, null, 8, ["modelValue"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (($setup.element3.type == 2)||($setup.element3.type == 3))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                                            _hoisted_97,
                                            _createVNode(_component_InputText, {
                                              id: "automessage2",
                                              type: "text",
                                              modelValue: $setup.element3.payload,
                                              "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (($setup.element3.payload) = $event))
                                            }, null, 8, ["modelValue"]),
                                            ($setup.element3.payload?.length > 0)
                                              ? (_openBlock(), _createElementBlock("small", _hoisted_98, "Nội dung tin nhắn có độ dài " + _toDisplayString($setup.element3.payload?.length) + " ký tự (tối đa 1000 ký tự).", 1))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      ($setup.element3.type == 4)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                                            _hoisted_100,
                                            _createVNode(_component_InputText, {
                                              id: "smscontent2",
                                              type: "text",
                                              modelValue: $setup.payload2.content,
                                              "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (($setup.payload2.content) = $event))
                                            }, null, 8, ["modelValue"]),
                                            ($setup.payload2.content?.length > 0)
                                              ? (_openBlock(), _createElementBlock("small", _hoisted_101, "Nội dung tin nhắn có độ dài " + _toDisplayString($setup.payload2.content?.length) + " ký tự (tối đa 160 ký tự).", 1))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (($setup.element3.type == 4)||($setup.element3.type == 5))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                                            _hoisted_103,
                                            _createVNode(_component_InputMask, {
                                              mask: "(9999)999999",
                                              modelValue: $setup.payload2.phone_code,
                                              "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (($setup.payload2.phone_code) = $event)),
                                              placeholder: ""
                                            }, null, 8, ["modelValue"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_AccordionTab, { header: "Tham số 3" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_104, [
                                      _createElementVNode("div", _hoisted_105, [
                                        _hoisted_106,
                                        _createVNode(_component_InputText, {
                                          id: "title3",
                                          type: "text",
                                          modelValue: $setup.element4.title,
                                          "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (($setup.element4.title) = $event))
                                        }, null, 8, ["modelValue"]),
                                        ($setup.element4.title?.length > 0)
                                          ? (_openBlock(), _createElementBlock("small", _hoisted_107, "Tiêu đề đang có độ dài " + _toDisplayString($setup.element4.title?.length) + " ký tự (tối đa 100 ký tự).", 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("div", _hoisted_108, [
                                        _hoisted_109,
                                        _createElementVNode("div", _hoisted_110, [
                                          _createVNode(_component_InputText, {
                                            id: "imageUrl3",
                                            type: "text",
                                            modelValue: $setup.element4.image_url,
                                            "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (($setup.element4.image_url) = $event))
                                          }, null, 8, ["modelValue"]),
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "choose-image-button",
                                            onClick: _cache[39] || (_cache[39] = ($event: any) => ($setup.showListImage(4)))
                                          }, "chọn hình")
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_111, [
                                        _hoisted_112,
                                        _createVNode(_component_Dropdown, {
                                          modelValue: $setup.element4.type,
                                          "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (($setup.element4.type) = $event)),
                                          options: $setup.list,
                                          optionLabel: "label",
                                          optionValue: "param",
                                          showClear: "true"
                                        }, null, 8, ["modelValue", "options"])
                                      ]),
                                      ($setup.element4.type == 1)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                                            _hoisted_114,
                                            _createVNode(_component_InputText, {
                                              id: "defaultUrl3",
                                              type: "text",
                                              modelValue: $setup.element4.url,
                                              "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => (($setup.element4.url) = $event))
                                            }, null, 8, ["modelValue"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (($setup.element4.type == 2)||($setup.element4.type == 3))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                                            _hoisted_116,
                                            _createVNode(_component_InputText, {
                                              id: "automessage3",
                                              type: "text",
                                              modelValue: $setup.element4.payload,
                                              "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (($setup.element4.payload) = $event))
                                            }, null, 8, ["modelValue"]),
                                            ($setup.element4.payload?.length > 0)
                                              ? (_openBlock(), _createElementBlock("small", _hoisted_117, "Nội dung tin nhắn có độ dài " + _toDisplayString($setup.element4.payload?.length) + " ký tự (tối đa 1000 ký tự).", 1))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      ($setup.element4.type == 4)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                                            _hoisted_119,
                                            _createVNode(_component_InputText, {
                                              id: "smscontent3",
                                              type: "text",
                                              modelValue: $setup.payload3.content,
                                              "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => (($setup.payload3.content) = $event))
                                            }, null, 8, ["modelValue"]),
                                            ($setup.payload3.content?.length > 0)
                                              ? (_openBlock(), _createElementBlock("small", _hoisted_120, "Nội dung tin nhắn có độ dài " + _toDisplayString($setup.payload3.content?.length) + " ký tự (tối đa 160 ký tự).", 1))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (($setup.element4.type == 4)||($setup.element4.type == 5))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                                            _hoisted_122,
                                            _createVNode(_component_InputMask, {
                                              mask: "(9999)999999",
                                              modelValue: $setup.payload3.phone_code,
                                              "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => (($setup.payload3.phone_code) = $event)),
                                              placeholder: ""
                                            }, null, 8, ["modelValue"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_AccordionTab, { header: "Tham số 4" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_123, [
                                      _createElementVNode("div", _hoisted_124, [
                                        _hoisted_125,
                                        _createVNode(_component_InputText, {
                                          id: "title4",
                                          type: "text",
                                          modelValue: $setup.element5.title,
                                          "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => (($setup.element5.title) = $event))
                                        }, null, 8, ["modelValue"]),
                                        ($setup.element5.title?.length > 0)
                                          ? (_openBlock(), _createElementBlock("small", _hoisted_126, "Tiêu đề đang có độ dài " + _toDisplayString($setup.element5.title?.length) + " ký tự (tối đa 100 ký tự).", 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("div", _hoisted_127, [
                                        _hoisted_128,
                                        _createElementVNode("div", _hoisted_129, [
                                          _createVNode(_component_InputText, {
                                            id: "imageUrl4",
                                            type: "text",
                                            modelValue: $setup.element5.image_url,
                                            "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => (($setup.element5.image_url) = $event))
                                          }, null, 8, ["modelValue"]),
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "choose-image-button",
                                            onClick: _cache[47] || (_cache[47] = ($event: any) => ($setup.showListImage(5)))
                                          }, "chọn hình")
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_130, [
                                        _hoisted_131,
                                        _createVNode(_component_Dropdown, {
                                          modelValue: $setup.element5.type,
                                          "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => (($setup.element5.type) = $event)),
                                          options: $setup.list,
                                          optionLabel: "label",
                                          optionValue: "param",
                                          showClear: "true"
                                        }, null, 8, ["modelValue", "options"])
                                      ]),
                                      ($setup.element5.type == 1)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_132, [
                                            _hoisted_133,
                                            _createVNode(_component_InputText, {
                                              id: "defaultUrl4",
                                              type: "text",
                                              modelValue: $setup.element5.url,
                                              "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => (($setup.element5.url) = $event))
                                            }, null, 8, ["modelValue"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (($setup.element5.type == 2)||($setup.element5.type == 3))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                                            _hoisted_135,
                                            _createVNode(_component_InputText, {
                                              id: "automessage4",
                                              type: "text",
                                              modelValue: $setup.element5.payload,
                                              "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => (($setup.element5.payload) = $event))
                                            }, null, 8, ["modelValue"]),
                                            ($setup.element5.payload?.length > 0)
                                              ? (_openBlock(), _createElementBlock("small", _hoisted_136, "Nội dung tin nhắn có độ dài " + _toDisplayString($setup.element5.payload?.length) + " ký tự (tối đa 1000 ký tự).", 1))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      ($setup.element5.type == 4)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
                                            _hoisted_138,
                                            _createVNode(_component_InputText, {
                                              id: "smscontent4",
                                              type: "text",
                                              modelValue: $setup.payload4.content,
                                              "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => (($setup.payload4.content) = $event))
                                            }, null, 8, ["modelValue"]),
                                            ($setup.payload4.content?.length > 0)
                                              ? (_openBlock(), _createElementBlock("small", _hoisted_139, "Nội dung tin nhắn có độ dài " + _toDisplayString($setup.payload4.content?.length) + " ký tự (tối đa 160 ký tự).", 1))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (($setup.element5.type == 4)||($setup.element5.type == 5))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_140, [
                                            _hoisted_141,
                                            _createVNode(_component_InputMask, {
                                              mask: "(9999)999999",
                                              modelValue: $setup.payload4.phone_code,
                                              "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => (($setup.payload4.phone_code) = $event)),
                                              placeholder: ""
                                            }, null, 8, ["modelValue"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["activeIndex"])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_142, [
                      _createVNode(_component_Button, {
                        label: "Gởi tin nhắn",
                        icon: "pi pi-plus-circle",
                        iconPos: "left",
                        onClick: _cache[54] || (_cache[54] = ($event: any) => ($setup.doSendMessageWithAttachment())),
                        disabled: !$setup.valid2()
                      }, null, 8, ["disabled"])
                    ])
                  ]),
                  _createElementVNode("aside", _hoisted_143, [
                    _createElementVNode("div", _hoisted_144, [
                      _hoisted_145,
                      _createElementVNode("div", _hoisted_146, [
                        _hoisted_147,
                        _createElementVNode("div", _hoisted_148, [
                          _createElementVNode("div", _hoisted_149, [
                            ($setup.element1.image_url)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: $setup.element1.image_url,
                                  alt: ""
                                }, null, 8, _hoisted_150))
                              : (_openBlock(), _createElementBlock("div", _hoisted_151, _hoisted_154))
                          ]),
                          _createElementVNode("div", _hoisted_155, [
                            _createElementVNode("div", _hoisted_156, _toDisplayString($setup.element1.title || "Tiêu đề khung chính"), 1),
                            _createElementVNode("div", _hoisted_157, _toDisplayString($setup.element1.subtitle || "Nội dung khung chính sẽ hiển thị tại đây."), 1)
                          ]),
                          _createElementVNode("div", _hoisted_158, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.previewElements, (item) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: item.key,
                                class: "zalo-preview-item"
                              }, [
                                _createElementVNode("div", _hoisted_159, [
                                  (item.image_url)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: item.image_url,
                                        alt: ""
                                      }, null, 8, _hoisted_160))
                                    : (_openBlock(), _createElementBlock("i", _hoisted_161))
                                ]),
                                _createElementVNode("div", _hoisted_162, [
                                  _createElementVNode("div", _hoisted_163, _toDisplayString(item.title || item.fallbackTitle), 1),
                                  (item.description)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_164, _toDisplayString(item.description), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            }), 128)),
                            ($setup.previewElements.length === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_165, " Các tham số sẽ hiển thị tại đây sau khi nhập tiêu đề hoặc chọn ảnh. "))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_166, [
      _createElementVNode("div", _hoisted_167, [
        _createVNode(_component_Dialog, {
          header: "Gởi tin nhắn",
          visible: $setup.loadingBar,
          "onUpdate:visible": _cache[55] || (_cache[55] = ($event: any) => (($setup.loadingBar) = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_168, [
              _hoisted_169,
              _createVNode(_component_ProgressBar, {
                mode: "indeterminate",
                style: {"height":".3em"}
              })
            ])
          ]),
          _: 1
        }, 8, ["visible"]),
        _createVNode(_component_ConfirmDialog)
      ]),
      _createElementVNode("div", _hoisted_170, [
        _createElementVNode("div", _hoisted_171, [
          _createElementVNode("div", _hoisted_172, [
            ($setup.show)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "image-picker-overlay",
                  onClick: _cache[59] || (_cache[59] = _withModifiers(($event: any) => ($setup.show = false), ["self"]))
                }, [
                  _createElementVNode("div", _hoisted_173, [
                    _createElementVNode("div", _hoisted_174, [
                      _hoisted_175,
                      _createElementVNode("button", {
                        type: "button",
                        class: "image-picker-close",
                        onClick: _cache[56] || (_cache[56] = ($event: any) => ($setup.show = false))
                      }, _hoisted_177)
                    ]),
                    _createElementVNode("div", _hoisted_178, [
                      _createVNode(_component_InputText, {
                        id: "find",
                        type: "text",
                        modelValue: $setup.find,
                        "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => (($setup.find) = $event)),
                        onInput: _cache[58] || (_cache[58] = ($event: any) => ($setup.search($event))),
                        placeholder: "Tìm kiếm"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_Button, {
                        label: "Xóa hình",
                        onClick: $setup.deleteImage,
                        icon: "pi pi-trash",
                        disabled: !$setup.validImageSelect()
                      }, null, 8, ["onClick", "disabled"])
                    ]),
                    ($setup.listImageFull.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_179, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.listImageFull, (image) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: image.link,
                              class: "image-picker-item"
                            }, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "image-picker-thumb",
                                onClick: ($event: any) => ($setup.imageClick(image.link))
                              }, [
                                _createElementVNode("img", {
                                  src: image.link,
                                  alt: ""
                                }, null, 8, _hoisted_181)
                              ], 8, _hoisted_180),
                              _createElementVNode("div", {
                                class: "image-picker-name",
                                title: image.fileName
                              }, _toDisplayString(image.fileName), 9, _hoisted_182),
                              _createElementVNode("label", _hoisted_183, [
                                _createVNode(_component_Checkbox, {
                                  modelValue: image.delete,
                                  "onUpdate:modelValue": ($event: any) => ((image.delete) = $event),
                                  binary: true
                                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                _hoisted_184
                              ])
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_185, " Chưa có hình ảnh trên máy chủ hoặc chưa tải được danh sách hình. "))
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ], 64))
}